// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".with-title-notification-section[data-v-07a200cc]{display:flex;flex-direction:column;justify-content:center;row-gap:4px;text-align:center}", ""]);
// Exports
module.exports = exports;
